import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';
import FeatureGuard from 'app/shared-components/FeatureGuard';
import PgdListLayout from './layouts/PgdListLayout';

const MarketplacePage = lazy(() => import('./use-cases/MarketplacePage'));
const PgdLogsPage = lazy(() => import('./use-cases/PgdLogsPage'));
const PurchasePage = lazy(() => import('./use-cases/PurchasePage'));
const CreatePgdRecordPage = lazy(() => import('./use-cases/CreatePgdRecordPage'));
const ViewPgdRecordPage = lazy(() => import('./use-cases/ViewPgdRecordPage'));

const PgdConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
            organisationSelector: false,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'pgd/logs/create',
      element: (
        <FeatureGuard flag="pgds">
          <CreatePgdRecordPage />
        </FeatureGuard>
      ),
    },
    {
      path: 'pgd/logs/:recordId',
      element: (
        <FeatureGuard flag="pgds">
          <ViewPgdRecordPage />
        </FeatureGuard>
      ),
    },
    {
      path: 'pgd',
      element: (
        <FeatureGuard flag="pgds">
          <PgdListLayout />
        </FeatureGuard>
      ),
      children: [
        {
          path: '',
          element: <Navigate to="marketplace" replace />,
        },
        {
          path: 'marketplace',
          element: <MarketplacePage />,
        },
        {
          path: 'logs',
          element: <PgdLogsPage />,
        },
        {
          path: 'purchase/:pgdId',
          element: <PurchasePage />,
        },
      ],
    },
  ],
};

export default PgdConfig;
